import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

export default function PrivateRoute({ children, adminOnly = false, roles }) {
  const {
    currentUser,
    userRole,
    loading
  } = useAuth()

  // React Router konum bilgisini yakalayalım
  const location = useLocation()

  // 1) Eğer hala loading ise, henüz kullanıcı bilgilerini bilmiyoruz demektir
  if (loading) {
    return <div>Veri yükleniyor...</div>
  }

  // 2) Kullanıcı henüz yoksa (yani giriş yapmamışsa) /login'e yönlendir
  if (!currentUser || currentUser.isAnonymous) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname }}
      />
    )
  }

  // 3) adminOnly bir rota ise ve kullanıcı admin değilse /'a yönlendir
  if (adminOnly && userRole !== 'admin') {
    return <Navigate to={userRole === 'report_viewer' ? '/reports/survey' : '/'} replace />
  }

  if (roles && !roles.includes(userRole)) {
    return <Navigate to={userRole === 'report_viewer' ? '/reports/survey' : '/'} replace />
  }

  // 4) Kullanıcının nickname'i yoksa, ancak şu an /profile sayfasında değilse, oraya yönlendir
  const hasNickname = currentUser.nickname && currentUser.nickname.trim() !== ''
  if (!hasNickname && location.pathname !== '/profile') {
    return <Navigate to="/profile" replace />
  }

  // 5) Tüm şartlar sağlandığında, hedef bileşeni render et
  return children
}
